import React, { useState, useEffect } from 'react';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    smartToy: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm3.5 6.5H8v-2h3v2zm0-3H8v-2h3v2zm0-3H8V9h3v2zm6 6h-3v-2h3v2zm0-3h-3v-2h3v2zm0-3h-3V9h3v2zm.5-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
      </svg>
    ),
    calendar: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
      </svg>
    ),
    build: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
      </svg>
    ),
    flash: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M7 2v11h3v9l7-12h-4l4-8z"/>
      </svg>
    ),
    email: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    speed: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.38 8.57l-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44z"/>
        <path d="M10.59 15.41a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83z"/>
      </svg>
    ),
    allDay: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    playArrow: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M8 5v14l11-7z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    translate: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"/>
      </svg>
    ),
    insights: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M7.5 14H10v-1H7.5v1zm0 3H10v-1H7.5v1zm0-6H10V9H7.5v2zm4.5 6h5v-1H12v1zm0-3h5v-1H12v1zm0-3h5V9H12v2zM7 18h14V6H7v12zM5 4v16h16V4H5z"/>
      </svg>
    ),
    notifications: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

// Modal Component
const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <MaterialIcon name="close" className="w-6 h-6" />
          </button>
        </div>
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  );
};

const Landing = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  
  // Waitlist form state
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: ''
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);
  const [smsConsent, setSmsConsent] = useState(false);

  const testimonials = [
    { quote: "Perfect for handling emergency calls when I'm on a job site.", author: "Mike, HVAC Pro", jobs: "24/7 Available", initial: "M" },
    { quote: "Never miss calls during emergency repairs anymore.", author: "Sarah, Plumber", jobs: "Always Answers", initial: "S" },
    { quote: "Handles appointment booking so I can focus on the work.", author: "Jim, Electrician", jobs: "Auto Booking", initial: "J" },
    { quote: "Professional service that understands my business needs.", author: "Lisa, Real Estate Agent", jobs: "Industry Smart", initial: "L" },
    { quote: "24/7 fire alarm monitoring calls handled perfectly.", author: "Tom, Fire Safety Systems", jobs: "+47 calls", initial: "T" },
    { quote: "Emergency lockout calls never go unanswered now.", author: "Carlos, Locksmith", jobs: "+15 jobs", initial: "C" }
  ];

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    // Validate required fields
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone || !waitlistData.business) {
      alert('Please fill in all fields');
      return;
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      // Your actual backend endpoint
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business.trim()
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        console.log('✅ Waitlist submission successful:', data);
        
        // Close modal after showing success for 2 seconds
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: '' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      // Show user-friendly error messages
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };

  return (
    <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
      {/* Header */}
      <header className="bg-white border-b border-gray-200 py-4 px-4 sm:px-6 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Left side - Demo */}
          <div>
            <a
              href="tel:+17863845350"
              className="text-blue-900 hover:text-blue-700 font-semibold text-sm sm:text-base"
            >
              Demo
            </a>
          </div>
          
          {/* Center - Logo */}
          <div className="text-xl sm:text-2xl font-black text-blue-900">receptioneer.ai</div>
          
          {/* Right side - Login */}
          <div>
            <button 
              onClick={goToLogin}
              className="text-blue-900 hover:text-blue-700 font-semibold text-sm sm:text-base"
            >
              Login
            </button>
          </div>
        </div>
      </header>
      
      {/* Hero Section with Dynamic Background */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-blue-100 overflow-hidden">
        {/* Subtle animated elements */}
        <div className="absolute inset-0 opacity-40">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
          <div className="absolute top-40 right-10 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl animate-pulse" style={{animationDelay: '2s'}}></div>
          <div className="absolute -bottom-32 left-1/3 w-72 h-72 bg-cyan-200 rounded-full mix-blend-multiply filter blur-xl animate-pulse" style={{animationDelay: '4s'}}></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
          <div className="text-center mb-12 sm:mb-16">
            {/* Live indicator */}
            <div className="inline-flex items-center bg-blue-900/10 text-blue-900 px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold mb-6 sm:mb-8">
              <div className="w-2 h-2 bg-blue-900 rounded-full mr-2 animate-pulse"></div>
              6,143 Calls Answered This Week
            </div>

            <h1 className={`text-3xl sm:text-5xl md:text-7xl font-black mb-6 sm:mb-8 transition-all duration-1000 leading-tight ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              It Answers. It Books. <br />It Works Nonstop.
            </h1>
            <p className="text-base sm:text-xl md:text-2xl text-gray-700 mb-8 sm:mb-12 max-w-4xl mx-auto leading-relaxed px-4">
              Tailored to your business. Customized with your services, schedule, and pricing.
              <br />
              <strong className="font-black"> It doesn't just sound like your team — it is your team.</strong>
              <br />
            </p>

            <div className="flex flex-col gap-4 sm:gap-6 justify-center items-center mb-12 sm:mb-16 px-4">
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full sm:w-auto bg-blue-900 hover:bg-blue-800 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-xl font-bold text-base sm:text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Join Waitlist →
              </button>
              
              <a
                href="tel:+17863845350"
                className="w-full sm:w-auto group flex items-center justify-center gap-3 bg-white border-2 border-blue-900 hover:bg-blue-900 text-blue-900 hover:text-white px-6 sm:px-8 py-4 sm:py-5 rounded-xl font-bold text-base sm:text-lg shadow-md hover:shadow-lg transition-all duration-300"
              >
                <div className="w-8 h-8 bg-blue-900 group-hover:bg-white rounded-full flex items-center justify-center transition-colors duration-300">
                  <MaterialIcon name="playArrow" className="w-4 h-4 text-white group-hover:text-blue-900" />
                </div>
                Call or Text for Demo
              </a>
              <p className="text-sm text-gray-600 max-w-sm mx-auto">
                <strong>(786) 384-5350</strong> - Call or text anytime for questions, demo, or pricing info
              </p>
            </div>

            {/* Real-time stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-200">
                <div className="text-3xl font-black text-blue-900 mb-2">90%</div>
                <div className="text-gray-600 font-semibold">Less time spent on the phone</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-200">
                <div className="text-3xl font-black text-blue-900 mb-2">24/7</div>
                <div className="text-gray-600 font-semibold">Answering Service</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-200">
                <div className="text-3xl font-black text-blue-900 mb-2">100%</div>
                <div className="text-gray-600 font-semibold">Call Intelligence</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Image Section */}
      <section className="py-24 px-6 bg-white relative">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 items-center gap-16">
          {/* Text Column */}
          <div className="order-2 md:order-1">
            <div className="inline-block bg-red-100 text-red-700 px-4 py-2 rounded-lg font-semibold mb-6">
              ⚠️ The Problem
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight">
              You're Bleeding Money
              <br />
              <span className="text-red-600">Every Ring</span>
            </h2>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-900 rounded-xl flex items-center justify-center text-white font-bold text-xl">
                  67%
                </div>
                <div>
                  <div className="font-bold text-lg text-gray-900">of service calls go unanswered</div>
                  <div className="text-gray-600">That's $1,200+ jobs walking away</div>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-900 rounded-xl flex items-center justify-center text-white font-bold text-lg">
                  3.2
                </div>
                <div>
                  <div className="font-bold text-lg text-gray-900">rings before they hang up</div>
                  <div className="text-gray-600">You've got seconds to win or lose</div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-900 rounded-xl flex items-center justify-center text-white font-bold text-lg">
                  $47K
                </div>
                <div>
                  <div className="font-bold text-lg text-gray-900">average annual loss per tech</div>
                  <div className="text-gray-600">From missed calls alone</div>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-900 p-6 rounded-r-xl">
              <div className="font-bold text-blue-900 mb-2 flex items-center gap-2">
                <MaterialIcon name="checkCircle" className="w-5 h-5" />
                The Solution
              </div>
              <div className="text-blue-800">AI that answers every call in under 2 seconds, books the job, and puts it straight in your calendar.</div>
            </div>
          </div>

          {/* Image Column */}
          <div className="order-1 md:order-2 relative">
            <div className="relative">
              <img
                src="/images/girlietruck.png"
                alt="Service truck with professional technician"
                className="rounded-3xl shadow-2xl w-full"
              />
              
              {/* Desktop floating testimonial */}
              <div className="absolute -bottom-8 -left-8 bg-white shadow-2xl rounded-2xl p-6 max-w-sm border border-gray-100 hidden md:block">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                    {testimonials[currentTestimonial].initial}
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{testimonials[currentTestimonial].author.split(',')[0]}</div>
                    <div className="text-sm text-gray-600">{testimonials[currentTestimonial].author.split(',')[1]}</div>
                  </div>
                </div>
                <div className="font-semibold text-gray-800 mb-2">
                  "{testimonials[currentTestimonial].quote}"
                </div>
                <div className="text-sm text-green-600 font-bold">
                  {testimonials[currentTestimonial].jobs}
                </div>
              </div>
            </div>
            
            {/* Mobile testimonial - below image */}
            <div className="mt-6 bg-white shadow-2xl rounded-2xl p-6 border border-gray-100 md:hidden">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                  {testimonials[currentTestimonial].initial}
                </div>
                <div>
                  <div className="font-bold text-gray-900">{testimonials[currentTestimonial].author.split(',')[0]}</div>
                  <div className="text-sm text-gray-600">{testimonials[currentTestimonial].author.split(',')[1]}</div>
                </div>
              </div>
              <div className="font-semibold text-gray-800 mb-2">
                "{testimonials[currentTestimonial].quote}"
              </div>
              <div className="text-sm text-green-600 font-bold">
                {testimonials[currentTestimonial].jobs}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works - Visual Process */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900">
              Three Steps to 
              <span className="text-blue-900"> More Jobs</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Simple setup. Immediate results. More money in your pocket.
            </p>
          </div>

          <div className="relative">
            {/* Connection arrows */}
            <div className="hidden lg:block absolute top-24 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700"></div>
            
            <div className="grid md:grid-cols-3 gap-12">
              {[
                {
                  step: "01",
                  icon: "phone",
                  title: "Phone Rings",
                  subtitle: "Customer calls your number",
                  detail: "Emergency repair, routine maintenance, or new install—doesn't matter what time.",
                  bgColor: "bg-blue-900"
                },
                {
                  step: "02", 
                  icon: "smartToy",
                  title: "AI Takes Over",
                  subtitle: "Qualifies, quotes, books",
                  detail: "Our AI asks the right questions, gathers the right info, and locks in the appointment.",
                  bgColor: "bg-blue-900"
                },
                {
                  step: "03",
                  icon: "calendar", 
                  title: "Job in Calendar",
                  subtitle: "You show up and get paid",
                  detail: "Customer details, location, and job specs automatically added to your calendar.",
                  bgColor: "bg-blue-900"
                }
              ].map((step, index) => (
                <div key={index} className="text-center relative">
                  <div className={`w-20 h-20 ${step.bgColor} rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg transform hover:scale-110 transition-transform duration-300`}>
                    <MaterialIcon name={step.icon} className="w-8 h-8 text-white" />
                  </div>
                  <div className="text-sm font-mono text-blue-900 font-bold mb-2">{step.step}</div>
                  <h3 className="text-2xl font-black mb-2 text-gray-900">{step.title}</h3>
                  <p className="text-lg font-semibold text-gray-700 mb-3">{step.subtitle}</p>
                  <p className="text-gray-600">{step.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEW: Call Intelligence Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
              Advanced Features
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900">
              Smart Call Intelligence
              <br />
              <span className="text-blue-900">That Actually Works</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Every call is captured, analyzed, and summarized. Plus intelligent escalation for emergencies and multilingual support for all customers.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Call Summaries */}
            <div className="bg-gray-50 rounded-3xl p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
                <MaterialIcon name="insights" className="w-8 h-8 text-blue-900" />
              </div>
              <h3 className="text-2xl font-black mb-4 text-gray-900">100% Call Intelligence</h3>
              <p className="text-gray-600 mb-6">
                Detailed summaries of every conversation. Know exactly what the customer needs, their urgency level, and budget before you even call back.
              </p>
              <div className="bg-white rounded-xl p-4 border border-gray-200">
                <div className="text-sm text-gray-700">
                  <div className="font-semibold text-green-700 mb-2">Call Summary:</div>
                  <div className="text-xs space-y-1">
                    <div>• Customer: Sarah Martinez</div>
                    <div>• Issue: Kitchen sink leak, urgent</div>
                    <div>• Budget: $200-500 range</div>
                    <div>• Preferred time: Tomorrow 9-11 AM</div>
                    <div>• Customer mood: Frustrated but polite</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Multilingual Support */}
            <div className="bg-gray-50 rounded-3xl p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                <MaterialIcon name="translate" className="w-8 h-8 text-green-700" />
              </div>
              <h3 className="text-2xl font-black mb-4 text-gray-900">Speaks Every Language</h3>
              <p className="text-gray-600 mb-6">
                Fluent in Spanish, English, and 40+ languages. Never lose a customer due to language barriers. Your AI adapts to their preferred language instantly.
              </p>
              <div className="bg-white rounded-xl p-4 border border-gray-200">
                <div className="text-sm space-y-2">
                  <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-green-500 rounded-full"></span>
                    <span className="text-gray-700">English (Native)</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-green-500 rounded-full"></span>
                    <span className="text-gray-700">Spanish (Fluent)</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-green-500 rounded-full"></span>
                    <span className="text-gray-700">French, German, Italian...</span>
                  </div>
                  <div className="text-xs text-gray-500 mt-2">+ 14 more languages</div>
                </div>
              </div>
            </div>

            {/* Emergency Escalation */}
            <div className="bg-gray-50 rounded-3xl p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
                <MaterialIcon name="notifications" className="w-8 h-8 text-red-700" />
              </div>
              <h3 className="text-2xl font-black mb-4 text-gray-900">Smart Escalation</h3>
              <p className="text-gray-600 mb-6">
                AI recognizes true emergencies and escalates immediately. Get instant alerts for gas leaks, electrical hazards, or flooding situations.
              </p>
              <div className="bg-white rounded-xl p-4 border border-gray-200">
                <div className="text-sm">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                    <span className="font-semibold text-red-700">EMERGENCY DETECTED</span>
                  </div>
                  <div className="text-xs text-gray-700 space-y-1">
                    <div>• Keywords: "gas smell", "emergency"</div>
                    <div>• Instant SMS sent to your phone</div>
                    <div>• Customer given immediate guidance</div>
                    <div>• Call priority: URGENT</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Feature highlight banner */}
          <div className="mt-16 bg-gradient-to-r from-blue-900 to-blue-800 rounded-3xl p-8 text-white text-center">
            <h3 className="text-2xl md:text-3xl font-black mb-4">
              Never Miss Important Details Again
            </h3>
            <p className="text-blue-100 text-lg max-w-2xl mx-auto mb-6">
              While you're fixing one job, our AI is capturing every detail from the next three. 
              Complete call transcripts, customer sentiment, and action items—all waiting for you.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <div className="bg-white/20 px-4 py-2 rounded-full">Full Transcripts</div>
              <div className="bg-white/20 px-4 py-2 rounded-full">Priority Scoring</div>
              <div className="bg-white/20 px-4 py-2 rounded-full">Instant Alerts</div>
              <div className="bg-white/20 px-4 py-2 rounded-full">20+ Languages</div>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Memory Feature */}
      <section className="py-24 px-6 bg-blue-900 text-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 items-center gap-16">
            {/* Text Column */}
            <div>
              <div className="inline-flex items-center bg-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <span className="w-2 h-2 bg-yellow-400 rounded-full mr-2 animate-pulse"></span>
                Industry First
              </div>
              
              <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight">
                We Remember
                <br />
                <span className="text-blue-200">Every Customer</span>
              </h2>
              
              <p className="text-xl text-blue-100 mb-8 leading-relaxed">
                First AI receptionist to remember your customers' history, preferences, and past jobs. 
                No more awkward "Can you remind me what we did last time?" conversations.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                    <MaterialIcon name="schedule" className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="font-bold text-lg text-white mb-1">Past Service History</div>
                    <div className="text-blue-200">"Hi Mrs. Johnson! Ready for your annual HVAC maintenance?"</div>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                    <MaterialIcon name="build" className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="font-bold text-lg text-white mb-1">Equipment Details</div>
                    <div className="text-blue-200">Knows their system model, warranty status, and maintenance schedule</div>
                  </div>
                </div>
                
             
              </div>
            </div>
            
            {/* Visual Column */}
            <div className="relative">
              <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
                <div className="bg-white rounded-2xl p-6 mb-6 shadow-2xl">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-blue-900 rounded-full flex items-center justify-center">
                      <MaterialIcon name="phone" className="w-4 h-4 text-white" />
                    </div>
                    <div className="text-gray-900 font-semibold">Incoming Call...</div>
                  </div>
                  <div className="text-gray-700 text-sm space-y-2">
                    <div><strong>Customer:</strong> Sarah Martinez</div>
                    <div><strong>Last Service:</strong> Pipe repair - Kitchen (Jan 15)</div>
                    <div><strong>Equipment:</strong> Kohler fixtures, 2019 install</div>
                    <div><strong>Preferred Time:</strong> Mornings (9-11 AM)</div>
                  </div>
                </div>
                
                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <div className="text-green-700 font-semibold mb-2">AI Response:</div>
                  <div className="text-green-600 text-sm">
                    "Hi Sarah! How's that kitchen pipe we fixed last month? 
                    I can schedule your bathroom faucet repair for tomorrow at 9:30 AM. 
                    Should work perfectly with your Kohler setup."
                  </div>
                </div>
              </div>
              
              {/* Floating memory indicators */}
              <div className="absolute -top-4 -right-4 bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full text-xs font-bold">
                Customer #1,247
              </div>
              <div className="absolute -bottom-4 -left-4 bg-green-400 text-green-900 px-3 py-1 rounded-full text-xs font-bold">
                3 Years of History
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof Banner */}
      <section className="py-16 px-6 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <div className="text-3xl font-black mb-2">25+</div>
              <div className="text-blue-100">Industries</div>
            </div>
            <div>
              <div className="text-3xl font-black mb-2">24/7</div>
              <div className="text-blue-100">Available</div>
            </div>
            <div>
              <div className="text-3xl font-black mb-2">$399</div>
              <div className="text-blue-100">Per Month</div>
            </div>
            <div>
              <div className="text-3xl font-black mb-2">24hrs</div>
              <div className="text-blue-100">Setup</div>
            </div>
          </div>
        </div>
      </section>

      {/* Integrations */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h3 className="text-3xl font-black mb-4 text-gray-900">Works With Your Existing Tools</h3>
          <p className="text-xl text-gray-600 mb-12">No complicated setup. Plug and play.</p>
          
          <div className="grid grid-cols-2 md:grid-cols-2 gap-6">
            {[
              { name: "Google Calendar", icon: "calendar" },
              { name: "Outlook", icon: "email" }
            ].map((integration, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <MaterialIcon name={integration.icon} className="w-8 h-8 text-blue-900" />
                </div>
                <div className="font-bold text-gray-800">{integration.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900">
              Simple Pricing.
              <br />
              <span className="text-blue-900">Unlimited Value.</span>
            </h2>
            <p className="text-xl text-gray-600">
              One flat rate. No setup fees. No per-call charges. Cancel anytime.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border border-gray-100 relative">
            <div className="text-center mb-8">
              <div className="text-6xl md:text-7xl font-black text-gray-900 mb-4">
                $399
                <span className="text-2xl text-gray-500 font-normal">/month</span>
              </div>
              <p className="text-xl text-gray-600">
                That's <strong className="text-blue-900">$13/day</strong> to never miss another job
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              {[
                "300 calls per month",
                "Smart appointment booking", 
                "Complete call intelligence",
                "All integrations included",
                "24/7 live support",
                "Custom AI training"
              ].map((feature, index) => (
                <div key={index} className="flex items-center gap-3 text-lg">
                  <MaterialIcon name="checkCircle" className="w-6 h-6 text-blue-900" />
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>

            <button 
              onClick={() => setShowWaitlistModal(true)}
              className="w-full bg-blue-900 hover:bg-blue-800 text-white py-6 rounded-2xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              Join Waitlist →
            </button>
            
            <p className="text-center text-gray-500 mt-4 text-sm">
              No credit card required • Cancel anytime • Full setup included
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-24 px-6 bg-blue-900 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight">
            Stop Losing Jobs.
            <br />
            Start Making Money.
          </h2>
          
          <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto opacity-90">
            Never miss a call again with our AI receptionist service.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button 
              onClick={() => setShowWaitlistModal(true)}
              className="bg-white text-blue-900 hover:bg-gray-100 px-12 py-6 rounded-2xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              Join Waitlist
            </button>
            
            <a
              href="tel:+17863845350"
              className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-6 rounded-2xl font-bold text-xl transition-all duration-300"
            >
              <div className="w-8 h-8 bg-white text-blue-900 rounded-full flex items-center justify-center">
                <MaterialIcon name="playArrow" className="w-4 h-4" />
              </div>
              Hear Our AI Live
            </a>
          </div>
        </div>
      </section>

      {/* Waitlist Modal */}
      <Modal
        isOpen={showWaitlistModal}
        onClose={() => setShowWaitlistModal(false)}
        title="Join the Waitlist"
      >
        {waitlistSuccess ? (
          <div className="text-center">
            <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-gray-900 mb-2">You're on the list!</h3>
            <p className="text-gray-600">We'll notify you when spots open up.</p>
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
              <input
                type="text"
                required
                value={waitlistData.name}
                onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Your name"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              <input
                type="email"
                required
                value={waitlistData.email}
                onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="your@email.com"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
              <input
                type="tel"
                required
                value={waitlistData.phone}
                onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="(555) 123-4567"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Trade/Business</label>
              <select
                required
                value={waitlistData.business}
                onChange={(e) => setWaitlistData({...waitlistData, business: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Select your trade</option>
                <option value="plumbing">Plumbing</option>
                <option value="electrical">Electrical</option>
                <option value="hvac">HVAC</option>
                <option value="general">General Contractor</option>
                <option value="roofing">Roofing</option>
                <option value="landscaping">Landscaping</option>
                <option value="other">Other</option>
              </select>
            </div>
            {/* SMS Consent Checkbox */}
<div className="bg-gray-50 p-4 rounded-lg">
  <label className="flex items-start gap-3">
    <input
      type="checkbox"
      checked={smsConsent}
      onChange={(e) => setSmsConsent(e.target.checked)}
      className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
      required
    />
    <span className="text-sm text-gray-600">
      I Consent to Receive SMS Notifications, Alerts from No Day Off / Receptioneer.ai. Message frequency varies. Message and data rates may apply. Text HELP to (786) 384-5330 for assistance. You can reply STOP to unsubscribe at any time. For more information, please review our{' '}
      <a 
        href="/privacy" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline font-medium"
      >
        Privacy Policy
      </a>.
    </span>
  </label>
</div>
            
            <button
              onClick={handleWaitlistSubmit}
              disabled={waitlistLoading}
              className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {waitlistLoading ? 'Joining...' : 'Join Waitlist'}
            </button>
          </div>
        )}
      </Modal>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-2xl font-black text-blue-900 mb-2">receptioneer.ai</div>
          <p className="text-gray-600 mb-6">AI receptionists for service professionals</p>
          
          {/* Legal Links */}
          <div className="flex items-center justify-center gap-4 mb-6">
            <a 
              href="/blog" 
              className="text-blue-900 hover:text-blue-700 font-medium transition-colors"
            >
              Blog
            </a>
            <span className="text-gray-300">|</span>
            <a 
              href="/privacy" 
              className="text-blue-900 hover:text-blue-700 font-medium transition-colors"
            >
              Privacy Policy
            </a>
            <span className="text-gray-300">|</span>
            <a 
              href="/terms" 
              className="text-blue-900 hover:text-blue-700 font-medium transition-colors"
            >
              Terms of Service
            </a>
            <span className="text-gray-300">|</span>
            <a 
              href="/industries" 
              className="text-blue-900 hover:text-blue-700 font-medium transition-colors"
            >
              Industries
            </a>
          </div>
          
          <p className="text-gray-400 text-sm">© 2025 receptioneer.ai powered by nodayoff. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Landing;